import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "../../../types/FmsTypes";
import { IMdNoticeDetail, IMdNoticeFields, IMdNoticeSearch, INoticeOrg, INoticeReceiver } from "./NoticeTypes";
import { IMdUserFields } from "../auth/user/UserTypes";


class NoticeService {
    /**
     * 新增公告
     * @param params 
     * @returns 
     */
    async insert(params: IMdNoticeFields) {
        const noticeUrl = "/oa/notice/insert";
        return await httpRequest.post<IMdNoticeDetail>(noticeUrl, params);
    }

    /**
     * 更新公告
     * @param params 
     * @returns 
     */
    async update(params: IMdNoticeFields) {
        const noticeUrl = "/oa/notice/update";
        return await httpRequest.post<boolean>(noticeUrl, params);
    }
    /**
     * 发布公告
     * @param params
     * @returns 
     */
    async publish(params: IMdNoticeFields) {
        const noticeUrl = `/oa/notice/publish`;
        return await httpRequest.post<boolean>(noticeUrl, params);
    }

    /**
     * 分页查询公告
     * @param params 
     * @returns 
     */
    async page(params: IMdNoticeSearch) {
        const noticeUrl = "/oa/notice/findPageForAdmin";
        return await httpRequest.post<IPage<IMdNoticeDetail>>(noticeUrl, params);
    }

    /**
     * 分页查询公告
     * @param params 
     * @returns 
     */
    async pageUser(params: IMdNoticeSearch) {
        const noticeUrl = "/oa/notice/findPageForEmp";
        return await httpRequest.post<IPage<IMdNoticeDetail>>(noticeUrl, params);
    }

    /**
     * 查询单条公告
     * @param id
     * @returns 
     */
    async findOne(id: string) {
        const noticeUrl = `/oa/notice/findOne/${id}`;
        return await httpRequest.post<IMdNoticeDetail>(noticeUrl);
    }

    /**
     * 撤回公告
     * @param id
     * @returns 
     */
    async cancel(id: string) {
        const noticeUrl = `/oa/notice/cancel/${id}`;
        return await httpRequest.post<boolean>(noticeUrl);
    }

    /**
     * 查询部门以及下属用户树
     * @returns
     */
    async findOrgTree() {
        const noticeUrl = "/oa/notice/findOrg";
        return await httpRequest.post<INoticeOrg[]>(noticeUrl)
    }

    /**
     * 查询部门下用户
     * @param orgCode
     * @returns
     */
    async findUserByOrg(orgCode: string) {
        const noticeUrl = `/oa/notice/findUserByOrg/${orgCode}`;
        const { retData } = await httpRequest.post<INoticeReceiver[]>(noticeUrl)
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }
    /**
     * 查询全部用户
     */
    async findUserAll() {
        const noticeUrl = `/auth/user/findAllUser`;
        const { retData } = await httpRequest.post<INoticeReceiver[]>(noticeUrl)
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }

    /**
     * 查询公告接收人
     * @param params
     * @returns
     */
    async findNoticeReceivers(params: IMdUserFields) {
        const noticeUrl = "/oa/notice/findNoticeReceivers";
        return await httpRequest.post<IMdUserFields[]>(noticeUrl, params)
    }

    /**
     * 标记公告已读
     * @param id
     * @param userCode
     * @returns
     */
    async readNotice(id: string, userCode: string) {
        const noticeUrl = `/oa/notice/readed/${id}/${userCode}`;
        return await httpRequest.post<IMdUserFields[]>(noticeUrl)
    }

    /**
     * 删除公告接收人
     * @param params
     * @returns
     */
    async removeNoticeReceivers(params: INoticeReceiver) {
        const noticeUrl = "/oa/notice/removeNoticeReceivers";
        return await httpRequest.post<boolean>(noticeUrl, params)
    }

    /**
     * 新增公告接收人
     * @param params
     * @returns
     */
    async insertNoticeReceivers(params: INoticeReceiver) {
        const noticeUrl = "/oa/notice/insertNoticeReceivers";
        return await httpRequest.post<boolean>(noticeUrl, params)
    }

    /**
     * 查询公告已读用户
     * @param id
     * @returns
     */
    async noticeReader(noticeId: string) {
        const noticeUrl = `/oa/notice/findReadedName/${noticeId}`;
        return await httpRequest.post<string[]>(noticeUrl)
    }

    /**
     * 查询公告未读用户
     * @param id
     * @returns
     */
    async noticeUnReader(noticeId: string) {
        const noticeUrl = `/oa/notice/findUnReadName/${noticeId}`;
        return await httpRequest.post<string[]>(noticeUrl)
    }

    /**
     * 更新公告接收人
     * @param params
     * @returns
     */
    async updateNoticeReceivers(params: INoticeReceiver) {
        const noticeUrl = "/oa/notice/updateNoticeReceivers";
        return await httpRequest.post<boolean>(noticeUrl, params)
    }

    /**
     * 下载附件
     * @param id
     * @returns
     */
    async downloadFile(id: string) {
        const noticeUrl = `/oa/notice/downloadAttach?id=${id}`;
        return await httpRequest.getFile(noticeUrl, { timeout: 30000 });
    }
    /**
     * 附件预览
     */
    async filePerview(fileName: string) {
        const noticeUrl = `onlinePreview?url=${fileName}`;
        return await httpRequest.get(noticeUrl,{ baseURL: "http://81.70.248.140:8012/", });
    }


}

export const noticeService = new NoticeService();
